// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"05ea6b6b","488":"6a5ae4f6","977":"3b6fa558"}[chunkId] + ".chunk.js";
};